import script from "./ThemeTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeTag.vue?vue&type=script&setup=true&lang=ts"

import "./ThemeTag.vue?vue&type=style&index=0&id=7d02770f&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d02770f"]])

export default __exports__